import axios from "axios";
import qs from "qs";
import { getMainDomain } from "./getMainDomain";
import { domainConfig } from "@/constants/domain.config";
import { getLangMap } from "@/utils/getLangMap.ts";
import { dataSourceAtom } from "@/atoms/app";
import { jotaiStore } from "@/atoms/store";
function getBaseURL() {
  const { domain } = useSubdomain();
  if (isDevEnv) {
    return import.meta.env.VITE_API_PROXY;
  } else if (getMainDomain() === "mobi321.com" || domain === "wx.mobi321.com") {
    return domainConfig["mobi321.com"];
  } else if (getMainDomain() === "24hweather.com") {
    return domainConfig["24hweather.com"];
  } else if (window.location.hostname === "test.comfortweather.com") {
    return domainConfig["test.comfortweather.com"];
  } else if (window.location.hostname === "test1.comfortweather.com") {
    return domainConfig["test1.comfortweather.com"];
  } else {
    return domainConfig["default"];
  }
}
const axiosConfig = {
  baseURL: getBaseURL(),
  timeout: 5 * 60 * 1000,
  // withCredentials: true,
  headers: { "Content-Type": "application/json" },
};
const instance = axios.create(axiosConfig);
const appendUrlParams = (url: string, params: Record<string, string>) => {
  const queryString = qs.stringify(params, { encode: false });
  return `${url}?${queryString}`;
};

instance.interceptors.request.use(
  (config: any) => {
   

    const locTimeZone = LocalStorage.getItem("TIME_ZONE");
    const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localTimeZone = locTimeZone || defaultTimeZone;
    if (isBuildTest) {
      const url = window.location.href;
      const regex = /pm=(\d+)/g;
      const match = url.match(regex);
      const params = {
        ...(config?.params?.Accept ? {} : { Accept: localTimeZone }),
        lan: getLangMap(),
      };
      config.url = match
        ? appendUrlParams(config.url, {
            ...params,
            ...match
              .join("&")
              .split("&")
              .reduce((acc, cur) => ({ ...acc, [cur.split("=")[0]]: cur.split("=")[1] }), {}),
          })
        : appendUrlParams(config.url, params);
    } else {
      config.url = appendUrlParams(config.url, {
        ...(config?.params?.Accept ? {} : { Accept: localTimeZone }),
        lan: getLangMap(),
      });
    }
    return config;
  },
  error => Promise.reject(error),
);

instance.interceptors.response.use(
  (response: any) => {
    const resData = response.data;
    // 临时测试 把wni标识显示在页面
    if (resData?.data?.f) {
      jotaiStore.set(dataSourceAtom, resData.data.f);
    }
    resData.data.info = resData.data?.baseInfo ?? resData.data?.info ?? {};
    delete resData.data.baseInfo;
    if (!isDevEnv) {
      trackApiFetch(response.config.url);
    }
    return resData;
  },
  error => Promise.reject(error),
);

const trackApiFetch = (apiUrl: string) => {
  gtag("event", "fetchApi", { api: apiUrl });
};

export default instance;
